module.exports = __webpack_public_path__ + "assets/img/warrior-name-58b54364.png";